import ApiService from './api.service';

const AdminToolService = token => {
    const api = ApiService.createApiInstance(token);

    return {
        dumpRedisDB() {
            return api.delete('/admin-tools/dump-redis-cache');
        },
        directAddVideo(eventId, videoUrl) {
            return api.post(`/videos/direct-add/${eventId}`, {
                convertedFilePath: videoUrl,
            });
        },
        fetchMuxAssetDownloadUrl(assetId) {
            return api.get(`/admin-tools/mux/get-asset-download-url/${assetId}`);
        },
    };
};

export default AdminToolService;
